export default __webpack_public_path__ + "static/media/NoirPro-Regular.33474975.eot";